import React, { useState, useEffect } from "react";
import {
    Grid, ClickAwayListener,
    Grow,
    Popper,
    Stack, Typography, Button, Box, Modal
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import { ReactComponent as ActionIcon } from "../assets/images/action-cta-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";

export default function ActionButton(props) {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [openAssessment, setOpenAssessment] = React.useState(false);
    const handleOpenAssessment = () => setOpenAssessment(true);
    const handleCloseAssessment = () => setOpenAssessment(false);
    const [answers, setAnswers] = useState([]);
    const [emailConfirmation, setEmailConfirmation] = useState(false);
    const [returnConfirmation, setReturnConfirmation] = useState(false);
    const [deliveryConfirmation, setDeliveryConfirmation] = useState(false);
    const [paymentConfirmation, setPaymentConfirmation] = useState(false);
    const viewResponse = () => {
        handleOpenAssessment();
        setOpen(false);
    };
    const anchorRef = React.useRef(null);
    const handleToggle = (e) => {
        // e.preventDefault();
        // e.stopPropagation();
        setOpen((prevOpen) => !prevOpen);
    };
    const handleConfirmPopup = () => {
        setEmailConfirmation(false);
    };
    useEffect(() => {
        document.addEventListener("scroll", () => {
            setOpen(false);
        });
    }, []);
    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === "Escape") {
            setOpen(false);
        }
    };
    return (
        <>
            <Grid>
                <Stack direction="row" spacing={2}>
                    <div className="assess-update d-grid">
                        <Button
                            ref={anchorRef}
                            // id="composition-button"
                            aria-controls={open ? "composition-menu" : undefined}
                            aria-expanded={open ? "true" : undefined}
                            aria-haspopup="true"
                            onClick={(e) => handleToggle(e)}
                            aria-label="Menu icon"
                            disableRipple="true"
                            style={{ paddingTop: '4px' }}
                        >
                            <Typography className="secondary-bg-color border-radius-4 p-10 d-flex">
                                <ActionIcon className="svg-icons" />
                            </Typography>
                        </Button>
                        <Popper
                            style={{ zIndex: "9" }}
                            open={open}
                            anchorEl={anchorRef.current}
                            role={undefined}
                            placement="bottom-start"
                            transition
                        >
                            {({ TransitionProps, placement }) => (
                                <Grow
                                    {...TransitionProps}
                                    style={{
                                        transformOrigin:
                                            placement === "bottom-start" ? "left top" : "left bottom",
                                    }}
                                >
                                    <Paper>
                                        <ClickAwayListener
                                            onClickAway={handleClose}
                                            tabIndex={0}
                                            onKeyPress={handleClose}
                                        >
                                            <MenuList
                                                autoFocusItem={open}
                                                id="composition-menu"
                                                aria-labelledby="composition-button"
                                                onKeyDown={handleListKeyDown}
                                            >
                                                {((props.row.order_status != "Returned" && props.row.order_status != "Delivered") && !["AM", "JM", "FK", "AB", "TD", "BA", "EF", "PF1", "PF2"].includes(props?.row?.business_type)) && <MenuItem onClick={() => navigate('/createCustomer', { state: { customerData: props.row, rePrint: true } })}>
                                                    <Typography className="gray9 f-16 font-weight-400 pt-5 pb-5">Re-Print</Typography>
                                                </MenuItem>}
                                                {!["AM", "JM", "FK", "AB", "TD", "BA", "EF", "PF1", "PF2"].includes(props?.row?.business_type) && <MenuItem onClick={() => navigate('/createCustomer', { state: { customerData: props.row, reOrder: true } })}>
                                                    <Typography className="gray9 f-16 font-weight-400 pt-5 pb-5">Re-Order</Typography>
                                                </MenuItem>}
                                                {(!["AM", "JM", "FK", "AB", "TD", "BA", "EF", "PF1", "PF2"].includes(props?.row?.business_type) && props.row.order_status !== "Returned") ? <MenuItem onClick={() => navigate('/createCustomer', { state: { customerData: props.row, edit: true } })}>
                                                    <Typography className="gray9 f-16 font-weight-400 pt-5 pb-5">Edit</Typography>
                                                </MenuItem> : ""}
                                                {(props.row.order_status != "Returned" && !["AM", "JM", "FK"].includes(props?.row?.business_type)) && <MenuItem onClick={() => {setReturnConfirmation(true); setOpen(false);}}>
                                                    <Typography className="gray9 f-16 font-weight-400 pt-5 pb-5">Return</Typography>
                                                </MenuItem>}
                                                {(props.row.order_status != "Returned" && props.row.order_status != "Delivered") && <MenuItem onClick={() => {setDeliveryConfirmation(true); setOpen(false);}}>
                                                    <Typography className="gray9 f-16 font-weight-400 pt-5 pb-5">Delivered</Typography>
                                                </MenuItem>}
                                                {(props.row.order_status === "Delivered" || props.row.order_status === "Dispatched" || props.row.order_status === "Returned") && <MenuItem onClick={() => {setPaymentConfirmation(true); setOpen(false);}}>
                                                    <Typography className="gray9 f-16 font-weight-400 pt-5 pb-5">Payment Done</Typography>
                                                </MenuItem>}
                                                {/* <MenuItem onClick={() => {props.updateCustomer(props.row, "Disputed"); setOpen(false);}}>
                                                    <Typography className="gray9 f-12 font-weight-400">Raise Dispute</Typography>
                                                </MenuItem> */}
                                                <MenuItem onClick={() => {setEmailConfirmation(true); setOpen(false);}}>
                                                    <Typography className="gray9 f-16 font-weight-400 pt-5 pb-5">Delete</Typography>
                                                </MenuItem>
                                            </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </div>
                </Stack>
            </Grid>
            <Modal
                open={paymentConfirmation}
                onClose={() => setPaymentConfirmation(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="modal-content inputcontrasts">
                    <Typography className="align-left">
                        <Typography
                            id="modal-modal-title"
                            variant="h5"
                            className="font-weight-700"
                        >
                            Confirmation
                        </Typography>
                        <Typography sx={{ mt: 2 }} className="sub-text-font">
                        Are you sure you want to update the payment status as <strong className="danger-color">Done</strong>?
                        </Typography>
                        <Typography className="text-end mt-20">
                            <Button
                                className="btn secondary-button m-r-10"
                                aria-label="button"
                            onClick={() => setPaymentConfirmation(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn primary-button"
                                onClick={() => props.updateCustomer(props.row, "Done")}
                                aria-label="verify"
                                disableRipple="true"
                            >
                                OK
                            </Button>
                        </Typography>
                    </Typography>
                </Box>
            </Modal>
            <Modal
                open={deliveryConfirmation}
                onClose={() => setDeliveryConfirmation(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="modal-content inputcontrasts">
                    <Typography className="align-left">
                        <Typography
                            id="modal-modal-title"
                            variant="h5"
                            className="font-weight-700"
                        >
                            Confirmation
                        </Typography>
                        <Typography sx={{ mt: 2 }} className="sub-text-font">
                        Are you sure you want to update the status as <strong className="danger-color">Delivered</strong>?
                        </Typography>
                        <Typography className="text-end mt-20">
                            <Button
                                className="btn secondary-button m-r-10"
                                aria-label="button"
                            onClick={() => setDeliveryConfirmation(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn primary-button"
                                onClick={() => props.updateCustomer(props.row, "Delivered")}
                                aria-label="verify"
                                disableRipple="true"
                            >
                                OK
                            </Button>
                        </Typography>
                    </Typography>
                </Box>
            </Modal>
            <Modal
                open={returnConfirmation}
                onClose={() => setReturnConfirmation(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="modal-content inputcontrasts">
                    <Typography className="align-left">
                        <Typography
                            id="modal-modal-title"
                            variant="h5"
                            className="font-weight-700"
                        >
                            Confirmation
                        </Typography>
                        <Typography sx={{ mt: 2 }} className="sub-text-font">
                        Are you sure you want to update the status as <strong className="danger-color">Returned</strong>?
                        </Typography>
                        <Typography className="text-end mt-20">
                            <Button
                                className="btn secondary-button m-r-10"
                                aria-label="button"
                            onClick={() => setReturnConfirmation(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn primary-button"
                                onClick={() => props.updateCustomer(props.row, "Returned")}
                                aria-label="verify"
                                disableRipple="true"
                            >
                                OK
                            </Button>
                        </Typography>
                    </Typography>
                </Box>
            </Modal>
            <Modal
                open={emailConfirmation}
                onClose={handleConfirmPopup}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="modal-content inputcontrasts">
                    <Typography className="align-left">
                        <Typography
                            id="modal-modal-title"
                            variant="h5"
                            className="font-weight-700"
                        >
                            Confirmation
                        </Typography>
                        <Typography sx={{ mt: 2 }} className="sub-text-font">
                        Are you sure you want to delete the customer?
                        </Typography>
                        <Typography className="text-end mt-20">
                            <Button
                                className="btn secondary-button m-r-10"
                                aria-label="button"
                            onClick={handleConfirmPopup}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn primary-button"
                                onClick={() => props.deleteCustomer(props.row.id)}
                                aria-label="verify"
                                disableRipple="true"
                            >
                                OK
                            </Button>
                        </Typography>
                    </Typography>
                </Box>
            </Modal>
        </>
    );
}
